export default __webpack_public_path__ + "static/media/3_SONGPRO.726bc74d.jpg";